<template>
<div id="content">
      <div class="productbg">
        <img src="./images/aboutbg.jpg" />
      </div>
  <div id="about">
            <div  id="info" v-if="$i18n.locale=='en'" v-html="info.remark_en"></div>
            <div  id="info" v-else v-html="info.remark"></div>
  </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'About',
  data() {
    return {
      info: {},
      id:6
    };
  },
  mounted() {
    if(this.$route.params.id)
    this.id = this.$route.params.id
    // alert(this.$route.params.id);
    // 使用
    const params = { id: this.id  }; // 参数
    fetch.post("/api/ApiSystemInfo/Get", params).then(
      (res) => {
        this.info = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods:{
    jumppage(p)
    {
    const params = { id: p  }; // 参数
    fetch.post("/api/ApiSystemInfo/Get", params).then(
      (res) => {
        this.info = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    }
  }
};
</script>

<style>
#about {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#cont {
  width:1400px; margin:20px auto auto;
}

#info {
  width:1400px; margin:auto ;
}


.productbg{
  margin: 0px;
padding: 0px;
height: 300px;
}
.productbg img{
  margin: 0px;
padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/DataInfo.vue